export default __webpack_public_path__ + "static/media/104.95a339ed.jpg";